import { component } from 'picoapp'
import { zelektor, loopify, clearInputs } from '@/lib/utility-functions.js'

export default component(node => {
	/*******************************************************************************************************************************************/
	/* Data + Elements
	/*******************************************************************************************************************************************/
	const { addressList, newAddressDialogue, openNewAddressBtn, editAddressDialogue, openEditAddressBtn, saveEditAddressBtn, cancelEditAddressBtn } = zelektor(node)
	let activeEdit = null;


	/*******************************************************************************************************************************************/
	/* Event Listeners
	/*******************************************************************************************************************************************/
	if (openEditAddressBtn) {
		loopify(openEditAddressBtn).forEach(btn => {
			btn.addEventListener('click', openEditAddress)
		})
	}

	if (saveEditAddressBtn) {
		loopify(saveEditAddressBtn).forEach(btn => {
			btn.addEventListener('click', () => {
				saveEditAddress(btn)
			})
		})
	}

	if (cancelEditAddressBtn) {
		loopify(cancelEditAddressBtn).forEach(btn => {
			btn.addEventListener('click', cancelEditAddress)
		})
	}

	if (openNewAddressBtn) {
		loopify(openNewAddressBtn).forEach(btn => {
			btn.addEventListener('click', openNewAddress)
		})
	}


	/*******************************************************************************************************************************************/
	/* Functions
	/*******************************************************************************************************************************************/
	function openEditAddress(e) {
		const id = e.currentTarget.dataset.addressId
		activeEdit = editAddressDialogue.querySelector(`[data-address-id="${id}"]`)
		addressList.style.display = 'none'
		activeEdit.style.display = ''
		editAddressDialogue.style.display = ''
	}

	function saveEditAddress(btn) {
		btn.classList.contains('js-newAddress')
		? newAddressDialogue.querySelector('form').submit()
		: activeEdit.querySelector('form').submit()
	}

	function cancelEditAddress() {
		newAddressDialogue.style.display = 'none'
		editAddressDialogue.style.display = 'none'
		if (activeEdit) activeEdit.style.display = 'none'
		clearInputs(newAddressDialogue)
		addressList.style.display = ''
	}

	function openNewAddress() {
		addressList.style.display = 'none'
		newAddressDialogue.style.display = ''
	}
})